export { default as PlatformsBg } from './platforms-background.png';
export { default as TargetBg } from './target-background.png';
export { default as TargetIconImg } from './target-icon.png';
export { default as UserBg } from './user-background.png';
export { default as UserIconImg } from './user-icon.png';
